import {
    UPDATE_MINI_CART_DETAILS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_MINI_CART_DETAILS:
            return {
                ...state,
                SUBMIT_loading: false,
                status: action.updateMiniCartDetails,
                actionType: action.actionType,
            }
        default:
            return state
    }
}